import React, { useState } from 'react';
import WooService from '../services/WooService';

const PaymentMethodsContext = React.createContext();

const PaymentMethodsProvider = ({ children }) => {
    const [paymentMethods, setPaymentMethods] = useState(null);

    const loadPaymentMethods = async () => {
        if (!paymentMethods) {
            const wooService = new WooService();
            const wooPaymentMethods = await wooService.getWooPaymentMethods();
console.log("wooPaymentMethods: ", wooPaymentMethods);
            setPaymentMethods(wooPaymentMethods);
        }
    };

    return (
        <PaymentMethodsContext.Provider value={{ paymentMethods, loadPaymentMethods }}>
            {children}
        </PaymentMethodsContext.Provider>
    );
};

export { PaymentMethodsContext, PaymentMethodsProvider };